import { useSelector } from 'react-redux';

import { IDailyDeal, IDailyDealsType } from 'models/daily-deals/i-daily-deals';
import { IState } from 'models/reducers/i-state.interface';

import AnimatedTabs from 'components/animatedTabs/AnimatedTabs';
import EmptyPageSection from 'components/emptyPageSection/EmptyPageSection';

import DailyDealsNftCard from '../dailyDealsNftCard/DailyDealsNftCard';
import DailyDealsSales from '../dailyDealsSales/DailyDealsSales';
import styles from './dailyDealsSection.module.scss';

export interface IDailyDealsProps {
  deal: IDailyDeal;
}
const dealTypes: IDailyDealsType[] = ['LANDMARK', 'CITY', 'COUNTRY'];

const sortByType = (deals: IDailyDeal[]) =>
  deals.sort((a, b) => {
    const indexA = dealTypes.indexOf(a.type);
    const indexB = dealTypes.indexOf(b.type);

    if (indexA < indexB) {
      return -1;
    }
    if (indexA > indexB) {
      return 1;
    }
    return 0;
  });

const DailyDealsSection = () => {
  const { deals } = useSelector((state: IState) => state.dailyDeals);

  const existingTypes = deals.map((deal) => deal.type);
  const missingDeals = dealTypes
    .filter((type) => !existingTypes.includes(type))
    .map((type) => ({ asset: { id: 0 }, type, items: [] }));

  return (
    <div className="tw-w-full tw-max-w-[360px] tw-px-5 md:tw-px-0 lg:tw-max-w-none xl:tw-max-w-[780px]">
      <div className="tw-flex tw-w-[320px] tw-flex-col tw-items-center tw-overflow-hidden lg:tw-w-full">
        <AnimatedTabs
          classNameList="tw-mb-8 tw-w-full lg:tw-mb-10 lg:tw-w-full lg:tw-max-w-[512px]"
          list={dealTypes}
          classNamePanels="tw-flex tw-relative lg:tw-min-h-[645px] lg:tw-w-full xl:tw-min-h-[467px]"
          classNamePanel={styles['tab-panel']}
          panels={sortByType([...missingDeals, ...deals]).map((deal) => (
            <div className="tw-w-[320px] tw-px-4 tw-py-2 lg:tw-w-full lg:tw-p-5">
              <div className="tw-flex tw-flex-col tw-items-center lg:tw-w-auto lg:tw-flex-row lg:tw-items-start lg:tw-p-0">
                {!!deal.items.length ? (
                  <>
                    <DailyDealsNftCard deal={deal} />
                    <DailyDealsSales deal={deal} />
                  </>
                ) : (
                  <EmptyPageSection
                    className="tw-mx-auto tw-flex tw-min-h-[391px] tw-items-center tw-justify-center tw-text-center xl:tw-min-h-[367px]"
                    title={
                      <>
                        There are no offers at the moment.
                        <br />
                        Please come back later.
                      </>
                    }
                  />
                )}
              </div>
            </div>
          ))}
        />
      </div>
    </div>
  );
};

export default DailyDealsSection;
